module.exports = __webpack_public_path__ + "img/LinkedIn.537b9bc5.png";